





















import { collections, firestore } from "@/configs/firebase";
import { Routes } from "@/router/routes";
import { Vue, Component } from "vue-property-decorator";
import logger from "@/configs/logger";
import moment from "moment";

@Component
export default class PostDates extends Vue {
  loading = false;
  search = "";
  headers = [
    {
      text: "Name",
      align: "start",
      sortable: true,
      value: "name"
    },
    {
      text: "Premium",
      sortable: true,
      value: "premium"
    },
    {
      text: "Enrollment Fee",
      sortable: true,
      value: "enrollment_fee"
    },
    {
      text: "Post Date",
      sortable: true,
      value: "post_date_ts"
    },
    {
      text: "Status",
      value: "status"
    },
    {
      text: "Type",
      value: "type"
    }
  ];

  postDates: any[] = [];

  mounted() {
    this.getPostDates();
  }

  formatDate(ts: number) {
    return moment.unix(ts).calendar();
  }

  async getPostDates() {
    try {
      this.loading = true;
      const snapshot = await firestore()
        .collectionGroup("selected_products")
        .where("status", "==", "post_date")
        .where("post_date_ts", ">=", new Date())
        .limit(100)
        .orderBy("post_date_ts", "asc")
        .get();

      const res = snapshot.docs.map(doc => {
        const data = doc.data();
        return { id: `${doc.id}_${data.name}`, ...data };
      });
      logger("log", res);
      this.postDates = res;
    } catch (err) {
      logger("error", "post date error:", err);
    } finally {
      this.loading = false;
    }
  }
}
